import s from './ParagraphLine.module.scss';
import {TParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/types";

export const ParagraphLine = ({ children, className }: TParagraphLine) => {
    return (
        <p className={`${s.paragraph} ${className ? className : ''}`}>
            { children }
        </p>
    );
};